module.exports = __webpack_public_path__ + "img/1.113bcea8.jpg";